module.exports = __webpack_public_path__ + "static/details-11-0e32aab19d2c2810b735c13b058277d9.jpg";